<template>
  <v-dialog
    v-model="showDialog"
    max-width="440"
    scrollable
    :aria-label="$t('routes.guidedRecording.autocue.settings')"
    data-cy="guidedRecording-autocue-settingsDialog"
  >
    <template #activator="{ props: activatorProps }">
      <slot name="activator" :props="activatorProps" />
    </template>
    <v-card class="guided-autocue__settings">
      <v-card-title class="d-flex justify-space-between align-center">
        <span class="guided-autocue__settings-heading">{{ $t('routes.guidedRecording.autocue.settings') }}</span>
        <v-small-icon-btn
          :aria-label="$t('routes.guidedRecording.autocue.settingsClose')"
          data-cy="guidedRecording-autocue-settingsClose"
          @click="showDialog = false"
        >
          <v-icon aria-hidden="true">mdi-close</v-icon>
          <v-tooltip activator="parent" location="bottom">
            {{ $t('routes.guidedRecording.autocue.settingsClose') }}
          </v-tooltip>
        </v-small-icon-btn>
      </v-card-title>
      <v-card-text class="guided-autocue__controls pt-4">
        <v-btn-toggle
          :model-value="alignment"
          mandatory
          density="comfortable"
          variant="outlined"
          divided
          color="primary"
          :aria-label="$t('routes.guidedRecording.autocue.alignment')"
          data-cy="guidedRecording-autocue-alignment"
          @update:model-value="$emit('update:alignment', $event)"
        >
          <v-btn
            value="left"
            icon
            :aria-pressed="alignment === 'left'"
            :aria-label="$t('routes.guidedRecording.autocue.alignmentLeft')"
            data-cy="guidedRecording-autocue-alignmentLeft"
          >
            <v-icon aria-hidden="true">mdi-format-align-left</v-icon>
          </v-btn>
          <v-btn
            value="center"
            icon
            :aria-pressed="alignment === 'center'"
            :aria-label="$t('routes.guidedRecording.autocue.alignmentCenter')"
            data-cy="guidedRecording-autocue-alignmentCenter"
          >
            <v-icon aria-hidden="true">mdi-format-align-center</v-icon>
          </v-btn>
          <v-btn
            value="right"
            icon
            :aria-pressed="alignment === 'right'"
            :aria-label="$t('routes.guidedRecording.autocue.alignmentRight')"
            data-cy="guidedRecording-autocue-alignmentRight"
          >
            <v-icon aria-hidden="true">mdi-format-align-right</v-icon>
          </v-btn>
        </v-btn-toggle>
        <v-slider
          :model-value="fontSize"
          :min="14"
          :max="48"
          :step="2"
          :label="$t('routes.guidedRecording.autocue.fontSize')"
          :aria-label="$t('routes.guidedRecording.autocue.fontSize')"
          hide-details
          class="guided-autocue__font-size"
          data-cy="guidedRecording-autocue-fontSize"
          @update:model-value="$emit('update:fontSize', $event)"
        />
        <v-slider
          :model-value="scrollSpeed"
          :min="1"
          :max="80"
          :step="1"
          :label="$t('routes.guidedRecording.autocue.scrollSpeed', { speed: scrollSpeed })"
          :aria-label="$t('routes.guidedRecording.autocue.scrollSpeed', { speed: scrollSpeed })"
          :aria-valuetext="$t('routes.guidedRecording.autocue.scrollSpeedValue', { speed: scrollSpeed })"
          thumb-label
          hide-details
          class="guided-autocue__scroll-speed"
          data-cy="guidedRecording-autocue-scrollSpeed"
          @update:model-value="$emit('update:scrollSpeed', $event)"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'GuidedAutocueSettingsDialog',
  emits: ['update:modelValue', 'update:alignment', 'update:fontSize', 'update:scrollSpeed'],
  props: {
    modelValue: { type: Boolean, default: false },
    alignment: { type: String, required: true },
    fontSize: { type: Number, required: true },
    scrollSpeed: { type: Number, required: true },
  },
  computed: {
    showDialog: {
      get() { return this.modelValue; },
      set(value) { this.$emit('update:modelValue', value); },
    },
  },
};
</script>

<style lang="scss" scoped>
@layer app {
  .guided-autocue__settings-heading { white-space: normal; overflow-wrap: anywhere; }
  .guided-autocue__controls { display: flex; flex-direction: column; gap: 20px; }
  .guided-autocue__font-size,
  .guided-autocue__scroll-speed { inline-size: 100%; }
  .guided-autocue__settings :focus-visible { outline: 2px solid rgb(var(--v-theme-primary)); outline-offset: 2px; }
}
</style>
